export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";